<template lang="html">
	<div class="header">
		<div class="topBar">
		</div>
		<div class="nav">
			<div v-on:click="showNav">
				<div class="left-login" ></div>
				<div class="nav-index-text">导航</div>
			</div>
			<div v-bind:class="['nav-index-home',isHome ? 'nav-none' : '' ]">
				<router-link to="/home"><img src="../../assets/img/home-index.png"></router-link>
				<div class="nav-title">
					<span v-on:click="jump" class="home-index">{{navTitle}}-</span>
					<span class="sub-index">{{subTitle}}</span>
				</div>
			</div>
			<div class="right-logo"></div>
		</div>
		<div class="zhezhao" v-show="navIndex">
		</div>
		<div class="nav-index" v-show="navIndex">
			<div class="login-div">
				<div class="login-icon">
					<div class="imgContainer">
						<img src="../../assets/img/login-icon.png" />
					</div>
					<div id="login" class="login-text" v-on:click="login">{{userInfo}}</div>
					<div id="vipIn" class="login-text" v-show="vipInIndex" v-on:click="vipIn">我要入会</div>
					<img src="../../assets/img/close.png" class="closeImg" v-on:click="closeNav"/>
				</div>
			</div>
			<div class="nav-container homeNavIndex" v-show="homeIndex">
				<ul>
					<router-link to="/home"><li><img src="../../assets/img/home-index.png" class="now">首页</li>	</router-link>
					<a href="https://jf.gtja.com/mobile/mall/dist/index.html#/index/jhjfmob"><li><img src="../../assets/img/mall-index.png" >积分商城</li></a>
					<router-link to="/quanyi"><li><img src="../../assets/img/quanyi-index.png" >会员权益</li></router-link>
					<router-link to="/activity"><li><img src="../../assets/img/activity-index.png" >精彩活动</li></router-link>
					<router-link to="/surroundings"><li><img src="../../assets/img/zhoubian-index.png" >专属周边</li></router-link>
					<router-link to="/aboutUs"><li><img src="../../assets/img/us-index.png" >关于我们</li></router-link>
				</ul>
			</div>
			<div class="nav-container usNavIndex" v-show="aboutUsIndex">
				<ul>
					<router-link to="/aboutUs/us"><li><img src="../../assets/img/us-index-us-grey.png" >关于我们</li>	</router-link>
					<router-link to="/aboutUs/vipInfo"><li><img src="../../assets/img/us-index-vipIn-grey.png" >入会方式</li></router-link>
					<router-link to="/aboutUs/location"><li><img src="../../assets/img/us-index-location-grey.png" >地址与联络</li></router-link>
					<router-link to="/aboutUs/newVip"><li><img src="../../assets/img/us-index.png" >新手须知</li></router-link>
					<!-- <router-link to="/aboutUs/getJifen"><li><img src="../../assets/img/us-index-getJifen-grey.png" >如何获取积分？</li></router-link>
					<router-link to="/aboutUs/exchangeJifen"><li><img src="../../assets/img/us-index-exchange-grey.png" >如何兑换积分</li></router-link>
					<router-link to="/aboutUs/rules"><li><img src="../../assets/img/us-index-rules-grey.png" >免责条款</li></router-link> -->
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	import $ from 'jquery'
	import Server from '../../server/server.js'
	export default {
	  	name: 'CommonHeader',
	  	data(){
		  	return{
		  		userInfo:'登录',     //用户登录状态
		  		isHome:true,         //是否在首页
		  		navTitle:'',         //头部大标题
		  		subTitle:'',         //头部子标题
		  		navIndex:false,      //是否展示导航页索引
		  		aboutUsIndex:false,  //关于我们导航索引
		  		homeIndex:true,      //主界面导航索引
		  		vipInIndex:false,    //用户入会入口索引
		  	}
	  	},
	  	methods:{
	  		homeNav(){    //头部导航标题，以及隐藏导航界面的所在页面的高亮
	  			let url = window.location.href;
	  			let preUrl = document.referrer;
	  			if(url.indexOf('home')>-1){
	  				this.isHome = true;
	  				$('.homeNavIndex ul li').eq(0).addClass('now-index');
	  				$('.homeNavIndex ul li').eq(0).children('img').attr("src","./static/img/home-index-now.png");
	  			}else{
	  				this.isHome = false;
	  				this.navTitle = '首页';
	  				if(url.indexOf('quanyi')>-1){
	  					this.subTitle = '会员权益';
	  					$('.homeNavIndex ul li').eq(2).addClass('now-index');
	  					$('.homeNavIndex ul li').eq(2).children('img').attr("src","./static/img/quanyi-index-now.png");
	  				}
	  				if(url.indexOf('surroundings')>-1){
	  					this.subTitle = '专属周边';
	  					$('.homeNavIndex ul li').eq(4).addClass('now-index');
	  					$('.homeNavIndex ul li').eq(4).children('img').attr("src","./static/img/zhoubian-index-now.png");
	  				}
	  				if(url.indexOf('activity')>-1){
	  					$('.homeNavIndex ul li').eq(3).addClass('now-index');
	  					$('.homeNavIndex ul li').eq(3).children('img').attr("src","./static/img/activity-index-now.png");
	  					if(url.indexOf('activityDetail')>-1){
	  						if(preUrl.indexOf('activityList')){   //活动详情页面，头部大标题会根据上一页面链接来判断内容
	  							this.navTitle = '全部活动';
	  						}else{
	  							this.navTitle = '精彩活动';
	  						}
	  						this.subTitle = '活动详情';
	  					}else{
	  						this.subTitle = '精彩活动';
	  					}
	  					
	  				}
	  				if(url.indexOf('vipIn')>-1){
	  					this.subTitle = '登录';
	  				}
	  				if(url.indexOf('aboutUs')>-1){
	  					$('.homeNavIndex ul li').eq(5).addClass('now-index');
	  					this.subTitle = '关于我们';
	  					this.aboutUsIndex = true;
	  					this.homeIndex = false;
	  					if(url.indexOf('aboutUs/us')>-1){
	  						$('.usNavIndex ul li').eq(0).addClass('now-index');
	  						$('.usNavIndex ul li').eq(0).children('img').attr("src","./static/img/us-index-us-yellow.png");
	  					}
	  					if(url.indexOf('aboutUs/vipInfo')>-1){
	  						$('.usNavIndex ul li').eq(1).addClass('now-index');
	  						$('.usNavIndex ul li').eq(1).children('img').attr("src","./static/img/us-index-vipIn-yellow.png");
	  					}
	  					if(url.indexOf('aboutUs/location')>-1){
	  						$('.usNavIndex ul li').eq(2).addClass('now-index');
	  						$('.usNavIndex ul li').eq(2).children('img').attr("src","./static/img/us-index-location-yellow.png");
	  					}
	  					if(url.indexOf('aboutUs/newVip')>-1){
	  						$('.usNavIndex ul li').eq(3).addClass('now-index');
	  						$('.usNavIndex ul li').eq(3).children('img').attr("src","./static/img/us-index-yellow.png");//
	  					}
	  					if(url.indexOf('aboutUs/getJifen')>-1){
	  						$('.usNavIndex ul li').eq(4).addClass('now-index');
	  						$('.usNavIndex ul li').eq(4).children('img').attr("src","./static/img/us-index-getJifen-yellow.png");
	  					}

	  					if(url.indexOf('aboutUs/exchangeJifen')>-1){
	  						$('.usNavIndex ul li').eq(5).addClass('now-index');
	  						$('.usNavIndex ul li').eq(5).children('img').attr("src","./static/img/us-index-exchangeJifen-yellow.png");
	  					}
	  					if(url.indexOf('aboutUs/rules')>-1){
	  						$('.usNavIndex ul li').eq(6).addClass('now-index');
	  						$('.usNavIndex ul li').eq(6).children('img').attr("src","./static/img/us-index-rules-yellow.png");
	  					}
	  				}
	  				
	  			}
	  		},
	  		showNav:function(){
	  			if(!this.navIndex){
	  				this.navIndex = !this.navIndex;
	  			}
	  		},
	  		closeNav:function(){
	  			this.navIndex = false;
	  		},
	  		jump:function(){
	  			if(this.navTitle == '首页'){
	  				this.$router.push({path: '/home'});
	  			}
	  			if(this.navTitle == '全部活动'){
	  				this.$router.push({path: '/activityList'});
	  			}
	  			if(this.navTitle == '精彩活动'){
	  				this.$router.push({path: '/activity'});
	  			}
	  		},
	  		vipIn:function(){
	  			this.$router.push({path: '/vipIn'});
	  		},
	  		login:function(){
	  			let login_from = localStorage.getItem('login_from');
	  			if(login_from == 'wxweb'){
					let codeUrl = encodeURIComponent(window.location.href);
					let loginUrl = 'https://jf.gtja.com/moblogin?return_url=';
					let toLoginUrl = loginUrl+ window.location.href;
					// console.log(toLoginUrl);
					window.location.href = toLoginUrl;
				}
	  		}
	  	},
	  	mounted(){
			this.homeNav();
			Server.loadUserInfo().then((result) => {
		    	if(result.code == '0'){ //用户已登录
		    		let userInfo = JSON.parse(result.msg);
		    		let userType = userInfo.type;  // 会员等级
		    		this.userInfo = userInfo.name; //用户姓名
		    		if(userType == '0'){
		    			this.vipInIndex = true;    //用户非会员状态，展示入会入口
		    		}
		    	}else{
                    localStorage.setItem('login_from','wxweb');//未登录状态，一定不是从app进来
                }
		    })  
	  	}
	}
</script>
<style lang="less" scoped>
	.header{
		position:fixed;
		top:0;
		left:0;
		width:100%;
		z-index: 11;
		background: #fff;
		.topBar{
			background-image:linear-gradient(90deg, #f1e3bb 0%, #e0c385 100%);
			width:100%;
			height:20px;
		}
		.nav{
			display:inline-block;
			padding:30px 40px;
			height:130px;
			width:100%;
			.left-login{
				float:left;
				width:36px;
				height:28px;
				margin-top:21px;
				background-image:url(../../assets/img/login.png);
				background-size:100% 100%;
			}
			.nav-index-text{
				float:left;
				display:inline-block;
				margin-left:10px;
				margin-top:15px;
				font-size:28px;
				color:#ad8f5a;
				height:40px;
				line-height:40px;
			}
			.nav-index-home{
				float:left;
				display:inline-block;
				margin-left:40px;
				margin-top:15px;
				font-size:28px;
				img{
					width:36px;
					float:left;
				}
				.nav-title{
					float:left;
					margin-left:10px;
					height:40px;
					line-height:40px;
					.home-index{
						color:#b9b9b9;
						letter-spacing:0;
					}
					.sub-index{
						color:#ad8f5a;
						letter-spacing:0;
					}
				}
			}
			.nav-none{
				display:none;
			}
			.right-logo{
				float:right;
				width:215px;
				height:70px;
				background-image:url(../../assets/img/right-logo.png);
				background-size:100% 100%;
			}
		}
		.zhezhao{
			position: fixed;
		    z-index: 998;
		    top: 0;
		    right: 0;
		    bottom: 0;
		    left: 0;
		    -webkit-transition-duration: 400ms;
		    transition-duration: 400ms;
		    opacity: 1;
		    background:rgba(173,143,90,0.75);
		}
		.nav-index{
			display: block;
		    -webkit-transition-duration: 400ms;
		    transition-duration: 400ms;
		    position: fixed;
		    z-index: 10000;
		    width:100%;
		    padding:0 40px;
		    top:0;
		    .login-div{
		    	margin-top:40px;
		    	display:inline-block;
		    	width:100%;
		    	height:100px;
		    	.imgContainer{
		    		background:#ffffff;
					width:100px;
					height:100px;
					border-radius:100%;
					text-align:center;
					float:left;
					img{
						vertical-align:middle;
						width:40px;
						margin-top:30px;
					}
		    	}
		    	.login-text{
		    		margin-left:20px;
		    		font-size:28px;
					color:#ffffff;
					letter-spacing:1.4px;
					line-height:46px;
					text-align:left;
					float:left;
					margin-top:27px;
		    	}
		    	#vipIn{
		    		text-decoration:underline;
		    	}
		    	.closeImg{
		    		float:right;
		    		width:32px;
		    	}
		    }
		    .nav-container{
		    	margin-top:40px;
		    	padding-top:50px;
		    	padding-left:40px;
		    	background-image:linear-gradient(90deg, #ffffff 0%, #e1e1e1 100%);
				border-radius:10px 10px 0 0;
				width:80%;
				height:1000px;
				li{
					font-size:32px;
					color:#333333;
					letter-spacing:1.4px;
					text-align:left;
					list-style:none;
					margin-bottom:50px;
					height:50px;
					line-height:50px;
					img{
						width:32px;
						margin-right:20px;
						vertical-align: middle;
					}
				}
				.now-index{
					color:#ad8f5a;
				}
		    }
		}
		.none{
			display:none;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/commonHeader.vue